import styled from 'styled-components';

import { DropDownArrow, GenericDiv } from 'commonStyles';

export const AccordianWrapper = styled(GenericDiv)`
    cursor: pointer;
`;

export const ReportingArrow = styled(DropDownArrow)`
    cursor: pointer;
    transform : ${(props) => props.open ? 'rotate(225deg)' : ''}
`;
